import classNames from "classnames";
import styles from "./ContentSideBar.module.scss";
import guidelineColours from "../../components/AppTopicBanner/apptopicbanner.module.scss";
import useScreenSize from "../../hooks/useScreenSize";
import RelatedTopics from "./RelatedTopics";
import useAppModernisation from "../../hooks/useAppModernisation";
import { useSelector } from "react-redux";
import { expertGroupContent, headerHidden, updateContent } from "./ContentSideBarSlice";

const ContentSideBar = ({
  ditapath,
  expandExpertGroupsSideBar,
  expandUpdatesSideBar,
}) => {
  const { isTabletSize } = useScreenSize();
  const { isMobileView } = useAppModernisation();
  const showExpertGroupContent = useSelector(expertGroupContent);
  const updateContentToShow = useSelector(updateContent);
  const isHeaderHidden = useSelector(headerHidden);

  return (
    <div className={styles.sidebar}>
      <div className={classNames(styles.fixedContainer, isHeaderHidden ? styles.headerHidden : "")}>
        {updateContentToShow && (
          <div
            className={styles.expertContributorBox}
            onClick={expandUpdatesSideBar}
          >
            <div
              className={classNames(
                guidelineColours[ditapath.replace("/", "")],
                styles.colouredBox,
              )}
            ></div>
            <div
              className={classNames(
                isTabletSize ? "size-14 medium" : "size-16 medium",
                styles.expertContributorText,
              )}
            >
              <div className={styles.openIcon}>
                <div>Topic updates</div>
                <div>
                  <i className="tg-icons-Carat size-14 medium"></i>
                </div>
              </div>
              <div
                className={classNames("size-12 medium", styles.extraText)}
                dangerouslySetInnerHTML={{ __html: updateContentToShow }}
              ></div>
            </div>
          </div>
        )}
        {showExpertGroupContent && (
          <div
            className={styles.expertContributorBox}
            onClick={expandExpertGroupsSideBar}
          >
            <div
              className={classNames(
                guidelineColours[ditapath.replace("/", "")],
                styles.colouredBox,
              )}
            ></div>
            <div
              className={classNames(
                isTabletSize ? "size-14 medium" : "size-16 medium",
                styles.expertContributorText,
              )}
            >
              Expert contributors
            </div>
            <div className={styles.openIcon}>
              <i className="tg-icons-Carat"></i>
            </div>
          </div>
        )}
        {!isTabletSize && !isMobileView && <RelatedTopics />}
      </div>
    </div>
  );
};

export default ContentSideBar;
